// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_MortgageRepaymentType.proto

export enum ENUM_MortgageRepaymentType {
  MORTGAGE_REPAYMENT_TYPE_UNSPECIFIED = 'MORTGAGE_REPAYMENT_TYPE_UNSPECIFIED',
  MORTGAGE_REPAYMENT_TYPE_FULL_REPAYMENT = 'MORTGAGE_REPAYMENT_TYPE_FULL_REPAYMENT',
  MORTGAGE_REPAYMENT_TYPE_INTEREST_ONLY = 'MORTGAGE_REPAYMENT_TYPE_INTEREST_ONLY',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
